import type { ChannelsTranslations } from '../interfaces/channels';

export const channelsTranslations: ChannelsTranslations = {
  page_title: 'Channels',
  page_description:
    'Connect a channel and pick the agent that responds when a customer messages you.',

  channel_whatsapp: 'WhatsApp',
  channel_instagram: 'Instagram',
  channel_web: 'Web chat',
  coming_soon: 'Coming soon',
  coming_soon_description:
    'We are working on this integration. We will let you know when it is ready.',

  binding_title: 'Agent that responds',
  binding_description:
    'The selected agent handles every incoming message on this channel.',
  binding_loading: 'Loading binding…',
  binding_field_label: 'Active agent',
  binding_field_placeholder: 'Pick an agent',
  binding_field_no_agents: 'You do not have any agents yet.',
  binding_no_agents_cta: 'Create your first agent',
  binding_save: 'Save changes',
  binding_save_first_time: 'Bind agent',
  binding_status_active: 'Active',
  binding_status_inactive: 'Paused',
  binding_status_unbound: 'No agent bound',
  binding_pause: 'Pause replies',
  binding_resume: 'Resume replies',
  binding_unbind: 'Unbind',
  binding_open_agent: 'Open agent',
  binding_uses_default: 'Falls back to the default ({{agent}}) until you bind one.',

  default_section_title: 'Default for all numbers',
  default_section_description:
    'Used by every phone in this channel unless you override it below.',
  phones_section_title: 'Phone numbers in this WABA',
  phones_section_description:
    'Each line can keep the default agent or have its own — pick a different one for sales, support, etc.',
  phones_count: '{{count}} number',
  phone_inherits_default: 'Uses the default ({{agent}})',
  phone_no_default: 'No default agent — incoming messages are dropped.',
  phone_customize: 'Customize',
  phone_collapse: 'Hide custom binding',

  unbind_dialog_title: 'Unbind this channel?',
  unbind_dialog_description:
    'The number stops replying immediately. You can re-bind any time.',
  unbind_dialog_confirm: 'Unbind',
  unbind_dialog_cancel: 'Cancel',

  must_connect_first:
    'Connect this channel first to choose the agent that responds.',

  toast_bound: 'Agent bound to the channel.',
  toast_swapped: 'Active agent updated.',
  toast_paused: 'Channel paused.',
  toast_resumed: 'Channel resumed.',
  toast_unbound: 'Channel unbound.',

  error_agent_not_found:
    'That agent is not available anymore. Pick another one.',
  error_phone_not_found:
    'That phone number is not connected to this organization. Reconnect WhatsApp.',
  error_invalid_channel: 'This channel is not supported.',
  error_unknown: 'Something went wrong. Please try again.',
};
